export const getFormatNumber = (phoneNumber: string) => {
  const areaCode = phoneNumber.slice(0, 3);
  const firstPart = phoneNumber.slice(3, 6);
  const secondPart = phoneNumber.slice(6);

  return `(${areaCode}) ${firstPart}-${secondPart}`;
};
